// @flow
import React from 'react';
import type { Node } from 'react';

import { Provider, Connect } from '@rover/react-lib/components/utils/Redux';
import { camelize } from '@rover/utilities/object-utilities';
import {
  reducer as frontendConfiguration,
  effects as frontendConfigurationEffects,
} from '@rover/react-lib/redux/ducks/frontendConfiguration.duck';

import { reducer as countryConfiguration } from '@rover/react-lib/redux/ducks/countryConfiguration.duck';
import { scrubAPetData } from '@rover/react-lib/apis/pet.api';

import {
  reducer as pets,
  selectors as petsSelectors,
  actions as petsActions,
  effects as petsEffects,
} from '@rover/react-lib/redux/ducks/pets.duck';

import {
  reducer as personSummary,
  effects as personEffects,
  selectors as personSelectors,
} from '@rover/react-lib/redux/ducks/personSummary.duck';

import EmergencyFormPage from './EmergencyFormPage';

import type { AppProps } from '.';

const validEmergencyContactInfo = summary => {
  const privateSummary = summary.private || {};
  const emergencyContactName = privateSummary.emergencyContactName || '';
  const emergencyContactPhoneNumber = privateSummary.emergencyContactPhoneNumber || '';

  return (
    emergencyContactName &&
    emergencyContactName.length &&
    emergencyContactPhoneNumber &&
    !!emergencyContactPhoneNumber.length
  );
};

const selector = state => ({
  pets: petsSelectors.getPets(state),
  getIsPetsLoading: petsSelectors.getIsLoading(state),
  getIsPersonSummaryLoading: personSelectors.getIsLoading(state),
  isVetComplete: petsSelectors.getPets(state).every(pet => pet.veterinaryInformation),
  isCareComplete: petsSelectors.getPets(state).every(pet => pet.careInstructions),
  isContactComplete: validEmergencyContactInfo(personSelectors.getPersonSummary(state)),
  personSummary: personSelectors.getPersonSummary(state),
});

const effects = {
  savePet: petsEffects.savePet,
  savePersonSummaryPrivate: personEffects.savePersonSummaryPrivate,
};

const EmergencyFormContainer = ({ pets: petsProp, ...props }: AppProps): Node => (
  <Provider reducers={{ frontendConfiguration, pets, personSummary, countryConfiguration }}>
    <Connect
      selector={selector}
      effects={effects}
      onMount={[
        frontendConfigurationEffects.fetchFrontendConfiguration,
        () => petsActions.fetchPetsSuccess(camelize(petsProp, true).map(scrubAPetData)),
        personEffects.fetchPersonSummary,
      ]}
    >
      {redux => <EmergencyFormPage {...redux} {...props} />}
    </Connect>
  </Provider>
);

export default EmergencyFormContainer;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/EmergencyFormPageContainer.jsx